import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";
import moment from "moment";

class RequestStates extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: "Pedidos por estado",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      labels: ["Pendentes", "Em curso", "Aceites", "Stand-by", "Cancelados"],
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };

  render() {
    return (
      <div class="ml-4 mt-4">
        <br />
        {this.props.requestStates && (
          <Chart
            title={this.state.title}
            options={this.state.chartOptions}
            series={[
              {
                name: "",
                data: [
                  this.props.requestStates[0].pendentes,
                  this.props.requestStates[0].em_curso,
                  this.props.requestStates[0].aceites,
                  this.props.requestStates[0].standby,
                  this.props.requestStates[0].cancelados,
                ],
              },
            ]}
            type="bar"
            width="480"
            height="400"
          />
        )}
        {(this.props.filter_date == null ||
          this.props.filter_date === moment().format("YYYY-MM-DD")) && (
          <div class="subtitle-grafs text-center mt-2">
            {" "}
            Pedidos colocados neste estado durante o dia de hoje.
          </div>
        )}
      </div>
    );
  }
}
export default RequestStates;
